import { DateInput as BaseDateInput, type DateInputProps as BaseDateInputProps } from '@mantine/dates'
import { type FC } from 'react'

export interface DateInputProps extends BaseDateInputProps {}

export const DateInput: FC<DateInputProps> = ({ popoverProps, ...props }) => (
  <BaseDateInput
    mb='xs'
    popoverProps={{
      withinPortal: true,
      zIndex: 1002,
      ...popoverProps
    }}
    radius='md'
    {...props}
  />
)
